module.exports = __webpack_public_path__ + "img/900500046.6ba7fe63.png";